import React, { Component } from 'react';
import AutosuggestHighlightMatch from 'autosuggest-highlight/match';
import AutosuggestHighlightParse from 'autosuggest-highlight/parse';
import { Tooltip, InfoIcon } from 'components';
import classnames from 'classnames';
import CheckedBox from './checkbox-checked.svg';
import UncheckedBox from './checkbox-unchecked.svg';
import './checkbox.scss';

export class Checkbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: '',
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const result = {};
    if (prevState.isChecked === '' && typeof nextProps.value === 'boolean') {
      result.isChecked = Boolean(nextProps.value);
    }
    result.isChecked = Boolean(nextProps.value);
    return result;
  }

  handleChange = () => {
    const { onChange, item, conversely } = this.props;
    const { isChecked } = this.state;

    this.setState((state) => ({
      isChecked: !state.isChecked,
    }));

    conversely ? onChange(item) : onChange(!isChecked);
  };

  renderLabelWithHighlightMatch = () => {
    const matches = AutosuggestHighlightMatch(
      this.props.label,
      this.props.searchValue,
    );
    const parts = AutosuggestHighlightParse(this.props.label, matches);

    return (
      <div className="autosuggestion-field__suggestion">
        {parts.map((part, index) => (
          <span
            className={classnames({
              'react-autosuggest__suggestion-match': part.highlight,
            })}
            key={index}
          >
            {part.text}
          </span>
        ))}
      </div>
    );
  };

  render() {
    const {
      tooltipInfo,
      tooltipType,
      tooltipWidth,
      label,
      name,
      addComponentClass,
      labelClass,
      conversely,
      isDisabledBox,
      isCheckedBox,
      highlightMatch,
    } = this.props;
    const { isChecked } = this.state;

    const CheckboxIcon = isChecked ? CheckedBox : UncheckedBox;

    const CheckboxIconMulti = isCheckedBox ? CheckedBox : UncheckedBox;

    return conversely ? (
      <div
        className={`checkbox-component ${addComponentClass} ${
          isDisabledBox && 'isDisabled_box'
        }`}
      >
        <input
          name={name}
          id={name}
          type="checkbox"
          onChange={!isDisabledBox ? this.handleChange : null}
          checked={isCheckedBox}
          value={isCheckedBox}
          disabled={isDisabledBox}
        />
        {label !== '' && (
          <label htmlFor={name} className="checkbox-multy__label">
            <div
              className={classnames(
                'checkbox-component__label-wrapper',
                labelClass,
              )}
            >
              {highlightMatch ? this.renderLabelWithHighlightMatch() : label}
            </div>
            <div className="checkbox__item">
              <CheckboxIconMulti />
            </div>
          </label>
        )}
      </div>
    ) : (
      <div className={`checkbox-component ${addComponentClass}`}>
        <input
          name={name}
          id={name}
          type="checkbox"
          onChange={this.handleChange}
          value={isChecked}
        />
        <CheckboxIcon />
        <label htmlFor={name}>
          <div
            className={classnames(
              'checkbox-component__label-wrapper',
              labelClass,
            )}
          >
            {label}
            {tooltipInfo && (
              <Tooltip
                style={{ top: '2px', left: '8px' }}
                width={tooltipWidth}
                type={tooltipType}
                info={tooltipInfo}
              >
                <InfoIcon width="17px" height="17px" />
              </Tooltip>
            )}
          </div>
        </label>
      </div>
    );
  }
}
